class CompositionOpener extends HTMLElement {
  constructor() {
    super();
    this.handleCompositionClick = this.handleCompositionClick.bind(this);
    this.handleHashChange = this.handleHashChange.bind(this);
  }

  connectedCallback() {
    this.setupEventListeners();
    this.checkInitialHash();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  setupEventListeners() {
    document.addEventListener('click', this.handleCompositionClick);
    window.addEventListener('hashchange', this.handleHashChange);
  }

  removeEventListeners() {
    document.removeEventListener('click', this.handleCompositionClick);
    window.removeEventListener('hashchange', this.handleHashChange);
  }

  handleCompositionClick(event) {
    const button = event.target.closest('.product-composition__benefits--button');
    if (!button) return;

    event.preventDefault();
    
    const href = button.getAttribute('href');
    if (href && href.includes('#anchor-composition')) {
      this.openCompositionAccordion();
    }
  }

  handleHashChange() {
    if (window.location.hash.includes('anchor-composition')) {
      this.openCompositionAccordion();
    }
  }

  checkInitialHash() {
    if (window.location.hash.includes('anchor-composition')) {
      setTimeout(() => {
        this.openCompositionAccordion();
      }, 100);
    }
  }

  openCompositionAccordion() {
    const anchor = document.getElementById('anchor-composition');
    if (!anchor) return;

    const details = anchor.querySelector('details');
    if (!details) return;

    if (!details.open) {
      details.open = true;
    }

    setTimeout(() => {
      const headerHeightVar = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
      const headerHeight = parseInt(headerHeightVar, 10) || 90;
      const offset = headerHeight + 16;
      const top = anchor.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }, 100);
  }
}

customElements.define('composition-opener', CompositionOpener);